import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const COLS = [
  {
    title: "Platform",
    links: [
      ["Platform Overview", "/platform"],
      ["AI Security", "/ai-security"],
      ["Governance & Standards", "/governance"],
      ["Assurance & Proof", "/assurance"],
    ],
  },
  {
    title: "Company",
    links: [
      ["Why Meira", "/why-meira"],
      ["About", "/about"],
      ["Contact", "/contact"],
      ["Book a Demo", "/contact"],
    ],
  },
  {
    title: "Trust",
    links: [
      ["Verify a Certificate", "/verify"],
      ["Security", "/why-meira"],
      ["Privacy", "/about"],
      ["Terms", "/about"],
    ],
  },
];

const FRAMEWORKS = ["ISO/IEC 42001", "EU AI Act", "NIST AI RMF", "OWASP LLM", "UAE PDPL"];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-line bg-panel-raised/40 pt-16 sm:pt-24">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-6 md:px-10">
        {/* three link columns stacked one per row is a very long scroll on a
            phone, so they sit two-up until the brand column can share a row */}
        <div className="grid gap-10 sm:grid-cols-2 sm:gap-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="sm:col-span-2 md:col-span-1">
            <Logo className="block h-5 w-auto" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-content-muted">
              Making AI safe, accountable, and provable. Test, govern and prove your AI with one assurance platform.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {FRAMEWORKS.map((f) => (
                <span key={f} className="rounded-full border border-line bg-panel-raised px-2.5 py-1 font-mono text-[9px] tracking-wide text-content-faint">
                  {f}
                </span>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-content-faint">{col.title}</div>
              <ul className="mt-4 flex flex-col gap-1 sm:mt-5 sm:gap-3">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="inline-flex min-h-[36px] items-center text-sm text-content-muted transition-colors hover:text-content sm:min-h-0">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-line py-7 text-[13px] text-content-faint sm:mt-20 sm:gap-4 sm:py-8 sm:text-sm sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Meira AI. All rights reserved.</span>
          <span className="font-mono text-[11px] tracking-wide">Making AI safe, accountable and provable.</span>
        </div>
      </div>

      <div aria-hidden="true" className="pointer-events-none select-none px-5 sm:px-6 md:px-10">
        <div className="font-display text-[16vw] font-medium leading-[0.8] tracking-tighter text-content/[0.035]">
          PROVE IT.
        </div>
      </div>
    </footer>
  );
}
